module.exports = __webpack_public_path__ + "img/p112.c98b47a0.png";